<style lang="scss" src="./assets/style.scss"></style>

<template>
  <div id="app">
    <portal-cabecalho-admin v-if="admin && admin.token"/>
    <portal-cabecalho :urlTrocaSenha="urlTrocaSenha" v-else/>

    <div class="page">
      <router-view/>
    </div>

    <portal-rodape/>
  </div>
</template>

<script>
  import PortalCabecalhoAdmin from './pages/admin/PortalCabecalhoAdmin'

  export default {
    components: {PortalCabecalhoAdmin},
    created () {
      this.urlTrocaSenha = this.$URL.TROCAR_SENHA
    },
    data () {
      return {
        urlTrocaSenha: ''
      }
    },
    computed: {
      parametros () {
        return this.$store.state.parametros
      },
      admin () {
        return this.$store.state.admin
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue